import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useCompositionInput
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useEffect, useRef, useState } from 'react';
import { useCombineCallback, useCombineRef } from '@tencent/glue-react-use';

function isKorean(text) {
  var reg = /((\uAC00-\uD7AF)|(\u3130-\u318F))+/gi;
  return reg.test(text);
}

export function useCompositionInput(options) {
  var value = options.value,
      inputRef = options.inputRef,
      onValueChange = options.onValueChange,
      onPressEnter = options.onPressEnter,
      onKeyDown = options.onKeyDown,
      onCompositionEnd = options.onCompositionEnd,
      onCompositionStart = options.onCompositionStart,
      onCompositionUpdate = options.onCompositionUpdate,
      onChange = options.onChange,
      onClear = options.onClear;

  var _useState = useState(value || ''),
      _useState2 = _slicedToArray(_useState, 2),
      userValue = _useState2[0],
      setUserValue = _useState2[1];

  var isOnComposition = useRef(false);
  var innerInputRef = useRef(null);

  var onComposition = function onComposition(e) {
    var text = e.currentTarget.value;
    var lastCharacter = text[text.length - 1] || '';
    isOnComposition.current = !isKorean(lastCharacter);
  };

  var combinedInputRef = useCombineRef(innerInputRef, inputRef);
  var onInputKeyDown = useCombineCallback(onKeyDown, function (e) {
    return e.keyCode === 13 && onPressEnter && onPressEnter(e);
  });
  var onInputCompositionStart = useCombineCallback(onCompositionStart, onComposition);
  var onInputCompositionUpdate = useCombineCallback(onCompositionUpdate, onComposition);
  var onInputCompositionEnd = useCombineCallback(onCompositionEnd, function (e) {
    var text = e.currentTarget.value;
    isOnComposition.current = false;
    setUserValue(text);
    onValueChange && onValueChange(text);
  });
  var onInputChange = useCombineCallback(function (e) {
    setUserValue(e.target.value);

    if (isOnComposition.current) {
      return;
    }

    onValueChange && onValueChange(e.target.value);
  }, onChange);
  var onClearButtonClick = useCombineCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    var input = innerInputRef.current;

    if (input == null) {
      return;
    }

    var event = Object.create(e);
    var originalInputValue = input.value;
    event.target = input;
    event.currentTarget = input;
    input.value = '';
    isOnComposition.current = false;
    input.value = originalInputValue;
    onValueChange && onValueChange('');
  }, onClear);
  useEffect(function () {
    if (value !== userValue) {
      setUserValue(value || '');
    }
  }, [value]);
  return {
    value: userValue,
    ref: combinedInputRef,
    onChange: onInputChange,
    onCompositionEnd: onInputCompositionEnd,
    onCompositionStart: onInputCompositionStart,
    onCompositionUpdate: onInputCompositionUpdate,
    onClearClick: onClearButtonClick,
    onKeyDown: onInputKeyDown
  };
}